// Oylan stand: the parent's view of the homework journal (#/roditel, no link on the home page).
// The solutions are on a separate site, oylan/build_parent_site.py.
import React from "react";
import homework from "../content-sources/oylan/homework.json";
import { loadJournal } from "./homework";
import { page } from "./HomeworkPage";
import { parentRows } from "./journalSync";

const cell = { padding: "6px 8px", borderBottom: "1px solid #ddd", textAlign: "left", verticalAlign: "top" };
const COLUMNS = ["Задача", "Статус", "Первый ответ", "Попыток", "Показано шагов", "Ошибается на шаге", "Повтор"];

export default function ParentPage() {
    const lessons = parentRows(homework, loadJournal());
    return (
        <div style={page}><div style={{ maxWidth: 960, margin: "0 auto" }}>
            <h2>Домашнее задание, журнал для родителя</h2>
            <p>Журнал этого браузера. «Показано» это шаги, которые Амаль не решила за две попытки и увидела готовыми.
                «Ошибается на шаге» это шаг, на котором она ошиблась два раза и больше.</p>
            {lessons.map((lesson, i) => (
                <table key={homework[i].lesson} style={{ borderCollapse: "collapse", width: "100%", marginBottom: 24 }}>
                    <caption style={{ textAlign: "left", fontWeight: 600 }}>{lesson.label}</caption>
                    <thead>
                    <tr>{COLUMNS.map((h) => <th key={h} style={cell}>{h}</th>)}</tr>
                    </thead>
                    <tbody>
                    {lesson.rows.map((r, j) => (
                        <tr key={r.task} data-testid={`parent-${homework[i].tasks[j].id}`}>
                            {[r.task, r.status, r.first, r.tries, r.shown, r.weak, r.due].map((v, k) => <td key={k} style={cell}>{v}</td>)}
                        </tr>
                    ))}
                    </tbody>
                </table>
            ))}
        </div></div>
    );
}
